import { Checkbox, TableCell } from "@mui/material"
import {
    getProjectBridgeSelectableScheduleIds,
    getProjectBridgeSelectedScheduleIds,
} from "./project-bridge-list-presenters"
import {
    deselectProjectBridgeScheduleIds,
    selectProjectBridgeScheduleIds,
    setProjectBridgeScheduleSelection,
    useProjectBridgeScheduleSelection,
} from "./project-bridge-selection"

export function ProjectBridgeSelectVisibleCheckbox({ items = [] }) {
    const selectedScheduleIdsById = useProjectBridgeScheduleSelection()
    const visibleSelectableScheduleIds = getProjectBridgeSelectableScheduleIds(items)
    const visibleSelectedScheduleIds = getProjectBridgeSelectedScheduleIds(selectedScheduleIdsById, items)
    const allVisibleSelected = Boolean(
        visibleSelectableScheduleIds.length && visibleSelectedScheduleIds.length === visibleSelectableScheduleIds.length
    )
    const someVisibleSelected = Boolean(visibleSelectedScheduleIds.length && !allVisibleSelected)

    return (
        <TableCell padding="checkbox">
            <Checkbox
                size="small"
                checked={allVisibleSelected}
                indeterminate={someVisibleSelected}
                disabled={!visibleSelectableScheduleIds.length}
                onChange={handleToggleVisibleSelection}
                inputProps={{ "aria-label": "Select visible Project Bridge schedules" }}
                data-cy="project-bridge-select-visible"
            />
        </TableCell>
    )

    function handleToggleVisibleSelection(event) {
        const { checked } = event.target

        if (checked) {
            setProjectBridgeScheduleSelection(
                selectProjectBridgeScheduleIds(selectedScheduleIdsById, visibleSelectableScheduleIds)
            )
            return
        }

        setProjectBridgeScheduleSelection(
            deselectProjectBridgeScheduleIds(selectedScheduleIdsById, visibleSelectableScheduleIds)
        )
    }
}
